import { Action } from "@ngrx/store";
import { ICustomUrl } from "@edp-models/deep-link.model";

export enum EDeepLinkActions {
    GetDeepLink = "[DeepLink] Get DeepLink",
    SetDeepLink = "[DeepLink] Set DeepLink",
}

export class GetDeepLink implements Action {
    public readonly type = EDeepLinkActions.GetDeepLink;
}

export class SetDeepLink implements Action {
    public readonly type = EDeepLinkActions.SetDeepLink;
    constructor(public payload: ICustomUrl) {}
}

export type DeepLinkActions =
    | GetDeepLink
    | SetDeepLink;
